interface getCasePieceSumPropsType {
  pieceCommittedQty: number;
  pieceAvailableQty: number;
  pieceUnsellableQty: number;
  pieceReturnedQty: number;
  pieceInTransitQty: number;
  pieceOnRouteQty: number;
  caseCommittedQty: number;
  caseAvailableQty: number;
  caseUnsellableQty: number;
  caseReturnedQty: number;
  caseInTransitQty: number;
  caseOnRouteQty: number;
  otherCommittedQty: number;
  otherAvailableQty: number;
  otherUnsellableQty: number;
  otherReturnedQty: number;
  otherInTransitQty: number;
  otherOnRouteQty: number;
}

export const getCasePieceSumProps = (props: getCasePieceSumPropsType) => {
  const {
    pieceCommittedQty,
    pieceAvailableQty,
    pieceUnsellableQty,
    pieceReturnedQty,
    pieceOnRouteQty,
    caseCommittedQty,
    caseAvailableQty,
    caseUnsellableQty,
    caseReturnedQty,
    caseOnRouteQty,
    otherCommittedQty,
    otherAvailableQty,
    otherUnsellableQty,
    otherReturnedQty,
    otherOnRouteQty,
    pieceInTransitQty,
    caseInTransitQty,
    otherInTransitQty,
  } = props;
  const pcQty =
    pieceAvailableQty + pieceCommittedQty + pieceOnRouteQty + pieceReturnedQty + pieceUnsellableQty + pieceInTransitQty;
  const csQty =
    caseAvailableQty + caseCommittedQty + caseOnRouteQty + caseReturnedQty + caseUnsellableQty + caseInTransitQty;
  const otherQty =
    otherAvailableQty + otherCommittedQty + otherOnRouteQty + otherReturnedQty + otherUnsellableQty + otherInTransitQty;
  return {
    pcQty: isNaN(pcQty) ? 0 : pcQty,
    csQty: isNaN(csQty) ? 0 : csQty,
    otherQty: isNaN(otherQty) ? 0 : otherQty,
  };
};
